module.exports = __webpack_public_path__ + "img/ring_g_o_0_1@2x.a511039b.png";